import throttle from 'lodash.throttle';

export default class LineClamp {
	constructor(els) {
		const $els = [].slice.call(document.querySelectorAll(els), 0);
		if ($els.length < 1)
			return;

		this.LINE_HEIGHT = 26;
		this.MAX_LINES = 3;
		this.MORE_TEXT = '&hellip; <span>Read more</span>';
		this.LESS_TEXT = '<span>Read less</span>';
		this.CLASSNAME = 'line-clamp-overflow';
		this.CLASSNAME_SHOW = 'line-clamp-overflow-show';
		this.readmore = null;

		$els.forEach((el) => {
			this._init(el);
		});

		window.addEventListener('resize', throttle(() => {
			$els.forEach((el) => {
				this._init(el);
			});
		}, 400));
	}

	_init(el) {
		this._destroy(el);

		if ( el.clientHeight <= (this.LINE_HEIGHT * this.MAX_LINES) )
			return;

		el.classList.add(this.CLASSNAME);
		this.readmore = document.createElement('span');
		this.readmore.className = 'read-more';
		this.readmore.innerHTML = this.MORE_TEXT;
		el.appendChild(this.readmore);
		this.readmore.addEventListener('click', this._expand.bind(this, event, el));
	}

	_expand(e, el) {
		el.classList.toggle(this.CLASSNAME_SHOW);
		if( el.classList.contains(this.CLASSNAME_SHOW) ) {
			this.readmore.innerHTML = this.LESS_TEXT;
		} else {
			this.readmore.innerHTML = this.MORE_TEXT;
		}
	}

	_destroy(el) {
		el.classList.remove(this.CLASSNAME, this.CLASSNAME_SHOW);
		var btn = el.querySelector('.read-more');
		if( btn !== null ) {
			btn.removeEventListener('click', this._expand);
			btn.remove();
		}
	}
};